import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, Bell, UserCircle } from 'lucide-react';
import { AdminSidebar } from './components/AdminSidebar';
export function AdminLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-cream flex font-body" data-id="element-403">
      <AdminSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-404" />

      {/* Overlay for mobile */}
      {isSidebarOpen && <div className="fixed inset-0 bg-earth/50 backdrop-blur-sm z-30 md:hidden transition-opacity" onClick={() => setIsSidebarOpen(false)} data-id="element-405" />}

      <div className="flex-1 flex flex-col md:ml-64 min-w-0 transition-all duration-300" data-id="element-406">
        <header className="h-16 bg-white border-b border-mist flex items-center justify-between px-4 md:px-8 sticky top-0 z-20 shadow-sm" data-id="element-407">
          <button className="md:hidden p-2 text-earth hover:bg-sand rounded-lg transition-colors" onClick={() => setIsSidebarOpen(true)} data-id="element-408">
            <Menu size={24} data-id="element-409" />
          </button>

          <div className="flex-1" data-id="element-410" />

          <div className="flex items-center gap-4" data-id="element-411">
            <button className="p-2 text-stone hover:bg-sand rounded-full relative transition-colors" data-id="element-412">
              <Bell size={20} data-id="element-413" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-error rounded-full border-2 border-white" data-id="element-414" />
            </button>
            <div className="flex items-center gap-3 pl-4 border-l border-mist" data-id="element-415">
              <div className="text-right hidden sm:block" data-id="element-416">
                <p className="text-sm font-bold text-earth leading-none" data-id="element-417">
                  Franchelis Vargas
                </p>
                <p className="text-xs text-stone mt-1" data-id="element-418">Administradora</p>
              </div>
              <UserCircle size={32} className="text-sage" data-id="element-419" />
            </div>
          </div>
        </header>

        <main className="flex-1 p-4 md:p-8 overflow-x-hidden" data-id="element-420">
          <Outlet data-id="element-421" />
        </main>
      </div>
    </div>;
}